const styles = (theme) => ({
  colorDefault: {
    backgroundColor: theme.color.grey_medium,
  },
});

export default styles;
